// import React, { useEffect, useState } from "react";
// import { DropdownButton, Dropdown } from "react-bootstrap";
// import Loader from "../utils/loader";
// import { toast } from "react-toastify";
// import DropDown from "./Cards/DropDown";
// import UserCard from "./Cards/UserCard";
// import { Popover, OverlayTrigger } from "react-bootstrap";
// import {
//   getAllManageUsers,
//   searchUser,
//   planFilter,
//   getAllUsers2,
// } from "../services/adminServices";
// import { withRouter } from "react-router-dom";
// import "./ManageUser.css";
// import BreadCrumb from "./Cards/BreadCrumbs";
// import team from "../static/noteams.png"
// import SearchBox from "./SearchBox";
// import { Typography } from "@material-ui/core";
// import DataGridMui from "./ReusableComponents/DataGridMui";

// const ManageUser = ({ history }) => {
//   let [loading, setLoading] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [usersBackup, setusersBackup] = useState([]);
//   let [chk, setChk] = useState([]);
//   const [drop, setDrop] = useState("");
//   const [page, setPage] = useState(0);
//   const [value, setvalue] = useState("");
//   const [filter, setfilter] = useState([]);
//   const [dashLink] = ["/admindashboard"];
//   const [LastPage, setLastPage] = useState(0);
//   const [planFilterDropDown, setPlanFilterDropDown] = useState("all");
//   const [isDarkMode, setIsDarkMode] = useState(false);
//    useEffect(() => {
//         const updateTheme = () => {
//             const theme = localStorage.getItem('ThemeSwitch');
//             setIsDarkMode(theme === 'true');
//         };
//         updateTheme();
//         window.addEventListener('storage', updateTheme);
//         const originalSetItem = localStorage.setItem;
//         localStorage.setItem = function (key, value) {
//             originalSetItem.apply(this, arguments);
//             if (key === 'ThemeSwitch') {
//             updateTheme();
//             }
//         };
//         return () => {
//             window.removeEventListener('storage', updateTheme);
//             localStorage.setItem = originalSetItem;
//         };
//         }, []);
//   // const [result, setresult] = useState([]);  ***db.users.find({name: /^${string}/i})
//   const showCard = 15;

//   //   const getAllUsers = async () => {
//   //     setLoading(true);
//   //     const res = await getAllManageUsers(showCard, page);
//   //     if (res.status === 200) {
//   //       setUsers(res.data);
//   //       setusersBackup(res.data);
//   //       setLastPage(Math.floor(res.pages - 1));
//   //       setfilter(res.data);
//   //       setLoading(false);
//   //     } else {
//   //       setLoading(false);
//   //       console.log("Oops something went worng");
//   //     }
//   //   };

//   const getAllUsers = async () => {
//     setLoading(true);
//     const res = await getAllUsers2();
//     console.log("getAllUsers", res)
//     if (res.status === 200) {
//       setUsers(res.data);
//       setusersBackup(res.data);
//       setfilter(res.data);
//       setLoading(false);
//     } else {
//       setLoading(false);
//       console.log("Oops something went worng");
//     }
//   };

//   const handleCheck = (getObj) => {
//     if (!drop) return;
//     if (chk.some((obj) => obj._id === getObj._id)) {
//       chk = chk.filter((obj) => obj._id !== getObj._id);
//     } else {
//       chk.push(getObj);
//     }

//     setChk([...chk]);
//     console.log(chk);
//   };

//   useEffect(() => {
//     getAllUsers();
//   }, [page]);

//   const handleSubmit = () => {
//     if (chk.length < 1) {
//       if (!drop) {
//         toast.error("Please select dropdown");
//         return;
//       }
//       toast.error("Please select any one of the User");
//       return;
//     }
//     const sendData = chk;
//     console.log(sendData, drop);
//     history.push({
//       pathname: `/Newsletter`,
//       state: { sendData, type: drop },
//     });
//   };

//   const goToSetting = (obj) => {
//     // console.log(obj);
//     history.push({
//       pathname: `/accountsettings`,
//       state: { userData: obj },
//     });
//   };

//   const goToDocument = (obj) => {
//     history.push({
//       pathname: `/mydocuments`,
//       state: { userData: obj },
//     });
//   };

//   // const searchDoc = search => {
//   //   console.log(search);
//   // };
//   const filterOnChange = async (e) => {
//     if (e.target.value === "") {
//       // console.log(e.target.value);
//       setPage(0);
//       setfilter(users);
//     }
//     setvalue(e.target.value);
//   };

//   const searchUsername = async () => {
//     let result = await searchUser(value);
//     setfilter(result);
//   };

//   const setDropDowm = (selection) => {
//     console.log(selection);
//     setDrop(selection);
//     if (selection === "newsletter") {
//       let filterData = usersBackup.filter((obj) => obj.subscription === true);
//       setUsers(filterData);
//     } else setUsers(usersBackup);
//   };

//   const FilterPlan = async (value) => {
//     setLoading(true);
//     setPlanFilterDropDown(value)
//     if (value === "all") {
//       setfilter(users);
//     } else {
//       let data = await planFilter(value);
//       setfilter(data.data);
//     }
//     setLoading(false);
//   };

//   const columns = [
//     // {
//     //     field: 'id', headerName: 'ID',
//     //     width: 90,
//     //     flex: 0.2,
//     // },
//     {
//       field: 'username',
//       headerName: 'User Name',
//       // width: 150,
//       flex: 0.5,
//       editable: false,
//     },
//     {
//       field: 'email',
//       headerName: 'Email',
//       type: 'text',
//       flex: 0.4,

//     },
//     {
//       field: 'country',
//       headerName: 'Country',
//       flex: 0.3,

//     },
//     {
//       field: 'phone',
//       headerName: 'Phone Number',
//       // type: 'number',
//       // width: 110,
//       flex: 0.4,
//     },
//     {
//       field: 'Role',
//       headerName: 'User Role',
//       flex: 0.3,
//     },
//     {
//       field: 'planName',
//       headerName: 'User Plan',
//       flex: 0.4,
//     },
//   ];

//   const sampleData = [
//     { id: 1, username: 'Lavanya', email: 'lavanya.g@gmail.com', phoneNumber: 9751266890 },
//     { id: 2, username: 'Ajith Kumar', email: 'ajith@gmail.com', phoneNumber: 8765675452 },
//     { id: 3, username: 'Vijay', email: 'vijay@gmail.com', phoneNumber: 9751266890 },
//     { id: 4, username: 'Balaji', email: 'balaji@gmail.com', phoneNumber: 9361724780 },
//     { id: 5, username: 'Shalini', email: 'shalini@gmail.com', phoneNumber: 12341234 },
//   ];

//   return (
//     <div>
//       <Loader loading={loading} />
//       {/* <BreadCrumb l1="Dashboard" l2="Manage Users" dashboardlink={dashLink} /> */}

//       <div className="container-fluid" style={{ background: isDarkMode?"black":"#f0f0f7" }}>
//         {/* <BreadCrumb l1="SubAdmin" l2="" dashboardlink="/dashboard" /> */}
//         {/* <div className="row justify-content-end w-100">
//           <div className="col-md-2 justify-content-end">
//             <OverlayTrigger
//               trigger="click"
//               placement="bottom"
//               // overlay={popover}
//               rootClose={true}
//             >
//               <button
//                 className="btn btn-primary inviteMember"
//                 style={{ width: "90%" }}
//                 disabled={true}
//               >
//                 Export
//               </button>
//             </OverlayTrigger>
//           </div>
//         </div> */}

//         <div className="row mt-2 w-100">
//           {/* {filterTeam.length === 0 ? ( */}
//           {users.length === 0 ? (
//             <div className="col-md-12 text-center">
//               <img src={team} alt="No Teams" />
//               <h3>No teams found!</h3>
//             </div>
//           ) : (
//             <>
//               <div className="col-md-12">
//                 <DataGridMui
//                   height="60vh"
//                   getRowId={(data) => data._id}
//                   columns={columns}
//                   rows={users}
//                 />
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default withRouter(ManageUser);

// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import Loader from "../utils/loader";
// import {
//   getAllUsers2,
//   searchUser,
//   planFilter,
// } from "../services/adminServices";
// import { withRouter } from "react-router-dom";
// import team from "../static/noteams.png";
// import DataGridMui from "./ReusableComponents/DataGridMui";

// import Grid from "@mui/material/Unstable_Grid2";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   InputAdornment,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Button,
//   Chip,
//   IconButton,
//   Stack,
//   Paper,
//   useTheme,
//   alpha,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import PersonIcon from "@mui/icons-material/Person";
// import EmailIcon from "@mui/icons-material/Email";

// const ManageUser = ({ history }) => {
//   let [loading, setLoading] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [usersBackup, setusersBackup] = useState([]);
//   let [chk, setChk] = useState([]);
//   const [drop, setDrop] = useState("");
//   const [value, setvalue] = useState("");
//   const [filter, setfilter] = useState([]);
//   const [planFilterDropDown, setPlanFilterDropDown] = useState("all");
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const theme = useTheme();

//   useEffect(() => {
//     const updateTheme = () => {
//       const theme = localStorage.getItem("ThemeSwitch");
//       setIsDarkMode(theme === "true");
//     };
//     updateTheme();
//     window.addEventListener("storage", updateTheme);
//     const originalSetItem = localStorage.setItem;
//     localStorage.setItem = function (key, value) {
//       originalSetItem.apply(this, arguments);
//       if (key === "ThemeSwitch") {
//         updateTheme();
//       }
//     };
//     return () => {
//       window.removeEventListener("storage", updateTheme);
//       localStorage.setItem = originalSetItem;
//     };
//   }, []);

//   const getAllUsers = async () => {
//     setLoading(true);
//     const res = await getAllUsers2();
//     console.log("getAllUsers", res);
//     if (res.status === 200) {
//       setUsers(res.data);
//       setusersBackup(res.data);
//       setfilter(res.data);
//       setLoading(false);
//     } else {
//       setLoading(false);
//       console.log("Oops something went wrong");
//     }
//   };

//   const handleCheck = (getObj) => {
//     if (!drop) return;
//     if (chk.some((obj) => obj._id === getObj._id)) {
//       chk = chk.filter((obj) => obj._id !== getObj._id);
//     } else {
//       chk.push(getObj);
//     }
//     setChk([...chk]);
//   };

//   useEffect(() => {
//     getAllUsers();
//   }, []);

//   const handleSubmit = () => {
//     if (chk.length < 1) {
//       if (!drop) {
//         toast.error("Please select dropdown");
//         return;
//       }
//       toast.error("Please select any one of the User");
//       return;
//     }
//     const sendData = chk;
//     history.push({
//       pathname: `/Newsletter`,
//       state: { sendData, type: drop },
//     });
//   };

//   const goToSetting = (obj) => {
//     history.push({
//       pathname: `/accountsettings`,
//       state: { userData: obj },
//     });
//   };

//   const goToDocument = (obj) => {
//     history.push({
//       pathname: `/mydocuments`,
//       state: { userData: obj },
//     });
//   };

//   const filterOnChange = async (e) => {
//     if (e.target.value === "") {
//       setfilter(users);
//     }
//     setvalue(e.target.value);
//   };

//   const searchUsername = async () => {
//     let result = await searchUser(value);
//     setfilter(result);
//   };

//   const setDropDowm = (selection) => {
//     setDrop(selection);
//     if (selection === "newsletter") {
//       let filterData = usersBackup.filter((obj) => obj.subscription === true);
//       setUsers(filterData);
//     } else setUsers(usersBackup);
//   };

//   const FilterPlan = async (value) => {
//     setLoading(true);
//     setPlanFilterDropDown(value);
//     if (value === "all") {
//       setfilter(users);
//     } else {
//       let data = await planFilter(value);
//       setfilter(data.data);
//     }
//     setLoading(false);
//   };

//   const columns = [
//     {
//       field: "username",
//       headerName: "User Name",
//       flex: 0.5,
//       editable: false,
//     },
//     {
//       field: "email",
//       headerName: "Email",
//       type: "text",
//       flex: 0.4,
//     },
//     {
//       field: "country",
//       headerName: "Country",
//       flex: 0.3,
//     },
//     {
//       field: "phone",
//       headerName: "Phone Number",
//       flex: 0.4,
//     },
//     {
//       field: "Role",
//       headerName: "User Role",
//       flex: 0.3,
//     },
//     {
//       field: "planName",
//       headerName: "User Plan",
//       flex: 0.4,
//     },
//   ];

//   // Stats Cards Data
//   // const statsData = [
//   //   {
//   //     title: "Total Users",
//   //     value: users.length,
//   //     icon: <PersonIcon />,
//   //     color: "#667eea",
//   //     bgColor: alpha("#667eea", 0.1),
//   //   },
//   //   {
//   //     title: "Active Plans",
//   //     value: users.filter((u) => u.planName).length,
//   //     icon: <EmailIcon />,
//   //     color: "#f093fb",
//   //     bgColor: alpha("#f093fb", 0.1),
//   //   },
//   // ];

//   return (
//     <Box
//       sx={{
//         minHeight: "80vh",
//         background: isDarkMode
//           ? "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)"
//           : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         py: 3,
//         px: { xs: 2, md: 3 },
//       }}
//     >
//       <Loader loading={loading} />

//       <Grid container spacing={3}>
//         {/* Filters Section */}
//         <Grid xs={12}>
//           <Card
//             sx={{
//               background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
//               backdropFilter: "blur(10px)",
//               border: `1px solid ${
//                 isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
//               }`,
//               borderRadius: 3,
//               p: 2,
//             }}
//           >
//             <Grid container spacing={2} alignItems="center">
//               <Grid xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by username or email..."
//                   value={value}
//                   onChange={filterOnChange}
//                   onKeyPress={(e) => e.key === "Enter" && searchUsername()}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon
//                           sx={{
//                             color: isDarkMode
//                               ? alpha("#fff", 0.5)
//                               : alpha("#000", 0.5),
//                           }}
//                         />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       backgroundColor: isDarkMode
//                         ? alpha("#fff", 0.05)
//                         : alpha("#667eea", 0.05),
//                       borderRadius: 2,
//                       "& fieldset": {
//                         borderColor: isDarkMode
//                           ? alpha("#fff", 0.1)
//                           : alpha("#667eea", 0.2),
//                       },
//                       "&:hover fieldset": {
//                         borderColor: "#667eea",
//                       },
//                       "& input": {
//                         color: isDarkMode ? "#fff" : "#2c3e50",
//                       },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid xs={12} md={3}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     sx={{
//                       color: isDarkMode
//                         ? alpha("#fff", 0.7)
//                         : alpha("#2c3e50", 0.7),
//                     }}
//                   >
//                     Filter by Plan
//                   </InputLabel>
//                   <Select
//                     value={planFilterDropDown}
//                     label="Filter by Plan"
//                     onChange={(e) => FilterPlan(e.target.value)}
//                     sx={{
//                       backgroundColor: isDarkMode
//                         ? alpha("#fff", 0.05)
//                         : alpha("#667eea", 0.05),
//                       borderRadius: 2,
//                       color: isDarkMode ? "#fff" : "#2c3e50",
//                       "& .MuiOutlinedInput-notchedOutline": {
//                         borderColor: isDarkMode
//                           ? alpha("#fff", 0.1)
//                           : alpha("#667eea", 0.2),
//                       },
//                       "&:hover .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#667eea",
//                       },
//                     }}
//                   >
//                     <MenuItem value="all">All Plans</MenuItem>
//                     <MenuItem value="free">Free</MenuItem>
//                     <MenuItem value="basic">Basic</MenuItem>
//                     <MenuItem value="premium">Premium</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid xs={12} md={3}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     sx={{
//                       color: isDarkMode
//                         ? alpha("#fff", 0.7)
//                         : alpha("#2c3e50", 0.7),
//                     }}
//                   >
//                     Action Type
//                   </InputLabel>
//                   <Select
//                     value={drop}
//                     label="Action Type"
//                     onChange={(e) => setDropDowm(e.target.value)}
//                     sx={{
//                       backgroundColor: isDarkMode
//                         ? alpha("#fff", 0.05)
//                         : alpha("#667eea", 0.05),
//                       borderRadius: 2,
//                       color: isDarkMode ? "#fff" : "#2c3e50",
//                       "& .MuiOutlinedInput-notchedOutline": {
//                         borderColor: isDarkMode
//                           ? alpha("#fff", 0.1)
//                           : alpha("#667eea", 0.2),
//                       },
//                       "&:hover .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#667eea",
//                       },
//                     }}
//                   >
//                     <MenuItem value="">None</MenuItem>
//                     <MenuItem value="newsletter">Newsletter</MenuItem>
//                     <MenuItem value="email">Email</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid xs={12} md={2}>
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   startIcon={<FileDownloadIcon />}
//                   sx={{
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     color: "#fff",
//                     borderRadius: 2,
//                     py: 1.5,
//                     textTransform: "none",
//                     fontWeight: 600,
//                     "&:hover": {
//                       background:
//                         "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                       transform: "translateY(-2px)",
//                       boxShadow: `0 6px 20px ${alpha("#667eea", 0.4)}`,
//                     },
//                   }}
//                 >
//                   Export
//                 </Button>
//               </Grid>
//             </Grid>
//           </Card>
//         </Grid>

//         {/* Data Grid Section */}
//         <Grid xs={12}>
//           {users.length === 0 ? (
//             <Card
//               sx={{
//                 background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
//                 backdropFilter: "blur(10px)",
//                 border: `1px solid ${
//                   isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
//                 }`,
//                 borderRadius: 3,
//                 p: 6,
//                 textAlign: "center",
//               }}
//             >
//               <img
//                 src={team}
//                 alt="No Teams"
//                 style={{ maxWidth: "300px", opacity: 0.6 }}
//               />
//               <Typography
//                 variant="h5"
//                 sx={{
//                   mt: 3,
//                   color: isDarkMode ? "#fff" : "#2c3e50",
//                   fontWeight: 600,
//                 }}
//               >
//                 No users found!
//               </Typography>
//             </Card>
//           ) : (
//             <Card
//               sx={{
//                 background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
//                 backdropFilter: "blur(10px)",
//                 border: `1px solid ${
//                   isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
//                 }`,
//                 borderRadius: 3,
//                 overflow: "hidden",
//               }}
//             >
//               <DataGridMui
//                 height="65vh"
//                 width="100%"
//                 getRowId={(data) => data._id}
//                 columns={columns}
//                 rows={users}
//               />
//             </Card>
//           )}
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default withRouter(ManageUser);

// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import Loader from "../utils/loader";
// import {
//   getAllUsers2,
//   searchUser,
//   planFilter,
// } from "../services/adminServices";
// import { withRouter } from "react-router-dom";
// import team from "../static/noteams.png";
// import DataGridMui from "./ReusableComponents/DataGridMui";

// // MUI Imports
// import Grid from "@mui/material/Unstable_Grid2";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   InputAdornment,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Button,
//   Chip,
//   IconButton,
//   Stack,
//   useTheme,
//   alpha,
//   CardHeader,
//   Avatar,
//   Tooltip,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import PersonIcon from "@mui/icons-material/Person";
// import EmailIcon from "@mui/icons-material/Email";
// import SettingsIcon from "@mui/icons-material/Settings";
// import DescriptionIcon from "@mui/icons-material/Description";
// import PeopleIcon from "@mui/icons-material/People";
// import PaidIcon from "@mui/icons-material/Paid";

// const ManageUser = ({ history }) => {
//   let [loading, setLoading] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [usersBackup, setusersBackup] = useState([]);
//   let [chk, setChk] = useState([]);
//   const [drop, setDrop] = useState("");
//   const [value, setvalue] = useState("");
//   const [filter, setfilter] = useState([]);
//   const [planFilterDropDown, setPlanFilterDropDown] = useState("all");
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   const theme = useTheme();

//   useEffect(() => {
//     const updateTheme = () => {
//       const theme = localStorage.getItem("ThemeSwitch");
//       setIsDarkMode(theme === "true");
//     };
//     updateTheme();
//     window.addEventListener("storage", updateTheme);
//     const originalSetItem = localStorage.setItem;
//     localStorage.setItem = function (key, value) {
//       originalSetItem.apply(this, arguments);
//       if (key === "ThemeSwitch") {
//         updateTheme();
//       }
//     };
//     return () => {
//       window.removeEventListener("storage", updateTheme);
//       localStorage.setItem = originalSetItem;
//     };
//   }, []);

//   const getAllUsers = async () => {
//     setLoading(true);
//     try {
//       const res = await getAllUsers2();
//       console.log("getAllUsers", res);
//       if (res.status === 200) {
//         setUsers(res.data);
//         setusersBackup(res.data);
//         setfilter(res.data);
//         setLoading(false);
//       } else {
//         setLoading(false);
//         console.log("Oops something went wrong");
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error("Error fetching users:", error);
//       toast.error("Failed to load users");
//     }
//   };

//   const handleCheck = (getObj) => {
//     if (!drop) return;
//     if (chk.some((obj) => obj._id === getObj._id)) {
//       chk = chk.filter((obj) => obj._id !== getObj._id);
//     } else {
//       chk.push(getObj);
//     }
//     setChk([...chk]);
//   };

//   useEffect(() => {
//     getAllUsers();
//   }, []);

//   const handleSubmit = () => {
//     if (chk.length < 1) {
//       if (!drop) {
//         toast.error("Please select an action type");
//         return;
//       }
//       toast.error("Please select at least one user");
//       return;
//     }
//     const sendData = chk;
//     history.push({
//       pathname: `/Newsletter`,
//       state: { sendData, type: drop },
//     });
//   };

//   const goToSetting = (obj) => {
//     history.push({
//       pathname: `/accountsettings`,
//       state: { userData: obj },
//     });
//   };

//   const goToDocument = (obj) => {
//     history.push({
//       pathname: `/mydocuments`,
//       state: { userData: obj },
//     });
//   };

//   const filterOnChange = async (e) => {
//     const searchValue = e.target.value;
//     setvalue(searchValue);

//     if (searchValue === "") {
//       setfilter(usersBackup);
//     } else {
//       const timer = setTimeout(async () => {
//         try {
//           let result = await searchUser(searchValue);
//           setfilter(result);
//         } catch (error) {
//           console.error("Search error:", error);
//         }
//       }, 500);
//       return () => clearTimeout(timer);
//     }
//   };

//   const searchUsername = async () => {
//     if (!value.trim()) {
//       setfilter(usersBackup);
//       return;
//     }
//     try {
//       let result = await searchUser(value);
//       setfilter(result);
//     } catch (error) {
//       console.error("Search error:", error);
//       toast.error("Failed to search users");
//     }
//   };

//   const setDropDowm = (selection) => {
//     setDrop(selection);
//     if (selection === "newsletter") {
//       let filterData = usersBackup.filter((obj) => obj.subscription === true);
//       setfilter(filterData);
//     } else {
//       setfilter(usersBackup);
//     }
//   };

//   const FilterPlan = async (value) => {
//     setLoading(true);
//     setPlanFilterDropDown(value);
//     try {
//       if (value === "all") {
//         setfilter(usersBackup);
//       } else {
//         let data = await planFilter(value);
//         setfilter(data.data);
//       }
//     } catch (error) {
//       console.error("Filter error:", error);
//       toast.error("Failed to filter users");
//     }
//     setLoading(false);
//   };

//   // Calculate stats
//   const totalUsers = users.length;
//   const activePlans = users.filter(
//     (u) => u.planName && u.planName.toLowerCase() !== "free"
//   ).length;
//   const freeUsers = users.filter(
//     (u) => !u.planName || u.planName.toLowerCase() === "free"
//   ).length;
//   const newsletterSubscribed = users.filter(
//     (u) => u.subscription === true
//   ).length;

//   // Enhanced columns with proper flex values for full width
//   const columns = [
//     {
//       field: "username",
//       headerName: "User Name",
//       flex: 0.8, // Increased flex value
//       minWidth: 180, // Added minWidth
//       editable: false,
//       renderCell: (params) => (
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//           <Avatar sx={{ width: 32, height: 32, bgcolor: "#667eea" }}>
//             {params.value ? params.value.charAt(0).toUpperCase() : "U"}
//           </Avatar>
//           <Typography variant="body2" sx={{ fontWeight: 500 }}>
//             {params.value || "N/A"}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: "email",
//       headerName: "Email Address",
//       type: "text",
//       flex: 1.2, // Increased flex value
//       minWidth: 220,
//       renderCell: (params) => (
//         <Typography
//           variant="body2"
//           sx={{ color: isDarkMode ? "#e0e0e0" : "#555" }}
//         >
//           {params.value || "N/A"}
//         </Typography>
//       ),
//     },
//     {
//       field: "country",
//       headerName: "Country",
//       flex: 0.6,
//       minWidth: 120,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           {params.value || "Not Specified"}
//         </Typography>
//       ),
//     },
//     {
//       field: "phone",
//       headerName: "Phone Number",
//       flex: 0.7,
//       minWidth: 140,
//       renderCell: (params) => (
//         <Typography variant="body2">{params.value || "N/A"}</Typography>
//       ),
//     },
//     {
//       field: "Role",
//       headerName: "User Role",
//       flex: 0.5,
//       minWidth: 100,
//       renderCell: (params) => (
//         <Chip
//           label={params.value || "User"}
//           size="small"
//           color={params.value === "Admin" ? "primary" : "default"}
//           variant="outlined"
//           sx={{ fontWeight: 500 }}
//         />
//       ),
//     },
//     {
//       field: "planName",
//       headerName: "Subscription Plan",
//       flex: 0.7,
//       minWidth: 150,
//       renderCell: (params) => {
//         const plan = params.value || "Free";
//         let color = "default";
//         if (plan.toLowerCase() === "premium") color = "success";
//         if (plan.toLowerCase() === "basic") color = "primary";
//         if (plan.toLowerCase() === "pro") color = "warning";

//         return (
//           <Chip
//             label={plan}
//             size="small"
//             color={color}
//             variant="filled"
//             sx={{
//               fontWeight: 600,
//               minWidth: 80,
//               color:
//                 color === "default" ? (isDarkMode ? "#fff" : "#000") : "#fff",
//             }}
//           />
//         );
//       },
//     },
//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 0.6,
//       minWidth: 130,
//       sortable: false,
//       renderCell: (params) => (
//         <Stack direction="row" spacing={0.5}>
//           <Tooltip title="Account Settings">
//             <IconButton
//               size="small"
//               onClick={() => goToSetting(params.row)}
//               sx={{
//                 color: isDarkMode ? "#90caf9" : "#1976d2",
//                 "&:hover": { bgcolor: alpha("#1976d2", 0.1) },
//               }}
//             >
//               <SettingsIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="View Documents">
//             <IconButton
//               size="small"
//               onClick={() => goToDocument(params.row)}
//               sx={{
//                 color: isDarkMode ? "#a5d6a7" : "#388e3c",
//                 "&:hover": { bgcolor: alpha("#388e3c", 0.1) },
//               }}
//             >
//               <DescriptionIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </Stack>
//       ),
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         minHeight: "80vh",
//         width: "100%",
//         background: isDarkMode
//           ? "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)"
//           : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         py: 3,
//         px: { xs: 2, md: 4 },
//       }}
//     >
//       <Loader loading={loading} />

//       <Grid container spacing={3} sx={{ width: "100%" }}>
//         {/* Filters Section */}
//         <Grid xs={12}>
//           <Card
//             sx={{
//               background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
//               backdropFilter: "blur(10px)",
//               border: `1px solid ${
//                 isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
//               }`,
//               borderRadius: 3,
//               p: 3,
//               width: "100%",
//             }}
//           >
//             <Grid container spacing={2} alignItems="center">
//               <Grid xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by name, email, or phone..."
//                   value={value}
//                   onChange={filterOnChange}
//                   onKeyPress={(e) => e.key === "Enter" && searchUsername()}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon
//                           sx={{
//                             color: isDarkMode
//                               ? alpha("#fff", 0.5)
//                               : alpha("#000", 0.5),
//                           }}
//                         />
//                       </InputAdornment>
//                     ),
//                     endAdornment: value && (
//                       <InputAdornment position="end">
//                         <Button
//                           size="small"
//                           onClick={() => {
//                             setvalue("");
//                             setfilter(usersBackup);
//                           }}
//                           sx={{ minWidth: "auto" }}
//                         >
//                           Clear
//                         </Button>
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     "& .MuiOutlinedInput-root": {
//                       backgroundColor: isDarkMode
//                         ? alpha("#fff", 0.05)
//                         : alpha("#667eea", 0.05),
//                       borderRadius: 2,
//                       "& fieldset": {
//                         borderColor: isDarkMode
//                           ? alpha("#fff", 0.1)
//                           : alpha("#667eea", 0.2),
//                       },
//                       "&:hover fieldset": {
//                         borderColor: "#667eea",
//                       },
//                       "& input": {
//                         color: isDarkMode ? "#fff" : "#2c3e50",
//                       },
//                     },
//                   }}
//                 />
//               </Grid>

//               <Grid xs={12} md={3}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     sx={{
//                       color: isDarkMode
//                         ? alpha("#fff", 0.7)
//                         : alpha("#2c3e50", 0.7),
//                     }}
//                   >
//                     Plan Type
//                   </InputLabel>
//                   <Select
//                     value={planFilterDropDown}
//                     label="Plan Type"
//                     onChange={(e) => FilterPlan(e.target.value)}
//                     sx={{
//                       backgroundColor: isDarkMode
//                         ? alpha("#fff", 0.05)
//                         : alpha("#667eea", 0.05),
//                       borderRadius: 2,
//                       color: isDarkMode ? "#fff" : "#2c3e50",
//                       "& .MuiOutlinedInput-notchedOutline": {
//                         borderColor: isDarkMode
//                           ? alpha("#fff", 0.1)
//                           : alpha("#667eea", 0.2),
//                       },
//                       "&:hover .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#667eea",
//                       },
//                     }}
//                   >
//                     <MenuItem value="all">All Plan Types</MenuItem>
//                     <MenuItem value="free">Free Plan</MenuItem>
//                     <MenuItem value="basic">Basic Plan</MenuItem>
//                     <MenuItem value="premium">Premium Plan</MenuItem>
//                     <MenuItem value="pro">Pro Plan</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid xs={12} md={3}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     sx={{
//                       color: isDarkMode
//                         ? alpha("#fff", 0.7)
//                         : alpha("#2c3e50", 0.7),
//                     }}
//                   >
//                     Bulk Actions
//                   </InputLabel>
//                   <Select
//                     value={drop}
//                     label="Bulk Actions"
//                     onChange={(e) => setDropDowm(e.target.value)}
//                     sx={{
//                       backgroundColor: isDarkMode
//                         ? alpha("#fff", 0.05)
//                         : alpha("#667eea", 0.05),
//                       borderRadius: 2,
//                       color: isDarkMode ? "#fff" : "#2c3e50",
//                       "& .MuiOutlinedInput-notchedOutline": {
//                         borderColor: isDarkMode
//                           ? alpha("#fff", 0.1)
//                           : alpha("#667eea", 0.2),
//                       },
//                       "&:hover .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#667eea",
//                       },
//                     }}
//                   >
//                     <MenuItem value="">Select Action</MenuItem>
//                     <MenuItem value="newsletter">Send Newsletter</MenuItem>
//                     <MenuItem value="email">Send Email</MenuItem>
//                     <MenuItem value="notification">Send Notification</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid xs={12} md={2}>
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   onClick={handleSubmit}
//                   disabled={!drop || chk.length === 0}
//                   startIcon={<EmailIcon />}
//                   sx={{
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     color: "#fff",
//                     borderRadius: 2,
//                     py: 1.5,
//                     textTransform: "none",
//                     fontWeight: 600,
//                     "&:disabled": {
//                       opacity: 0.5,
//                     },
//                     "&:hover:not(:disabled)": {
//                       background:
//                         "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                       transform: "translateY(-2px)",
//                       boxShadow: `0 6px 20px ${alpha("#667eea", 0.4)}`,
//                     },
//                   }}
//                 >
//                   {drop ? `Send ${drop}` : "Select Action"}
//                 </Button>
//               </Grid>
//             </Grid>

//             {chk.length > 0 && (
//               <Box
//                 sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}
//               >
//                 <Chip
//                   label={`${chk.length} user(s) selected`}
//                   color="primary"
//                   onDelete={() => setChk([])}
//                 />
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     color: isDarkMode ? alpha("#fff", 0.7) : "#64748b",
//                     ml: 1,
//                   }}
//                 >
//                   Click "Send {drop}" to proceed
//                 </Typography>
//               </Box>
//             )}
//           </Card>
//         </Grid>

//         {/* Data Grid Section */}
//         <Grid xs={12}>
//           {filter.length === 0 ? (
//             <Card
//               sx={{
//                 background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
//                 backdropFilter: "blur(10px)",
//                 border: `1px solid ${
//                   isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
//                 }`,
//                 borderRadius: 3,
//                 p: 6,
//                 textAlign: "center",
//                 width: "100%",
//               }}
//             >
//               <img
//                 src={team}
//                 alt="No Teams"
//                 style={{ maxWidth: "300px", opacity: 0.6 }}
//               />
//               <Typography
//                 variant="h5"
//                 sx={{
//                   mt: 3,
//                   color: isDarkMode ? "#fff" : "#2c3e50",
//                   fontWeight: 600,
//                 }}
//               >
//                 No users found!
//               </Typography>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   mt: 1,
//                   color: isDarkMode ? alpha("#fff", 0.7) : "#64748b",
//                 }}
//               >
//                 Try adjusting your search or filter criteria
//               </Typography>
//             </Card>
//           ) : (
//             <Card
//               sx={{
//                 background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
//                 backdropFilter: "blur(10px)",
//                 border: `1px solid ${
//                   isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
//                 }`,
//                 borderRadius: 3,
//                 overflow: "hidden",
//                 width: "100%",
//               }}
//             >
//               <CardHeader
//                 title="User Management Dashboard"
//                 sx={{
//                    mb: 1,
//                   background: isDarkMode
//                     ? alpha("#fff", 0.05)
//                     : alpha("#667eea", 0.05),
//                   borderBottom: `1px solid ${alpha(
//                     isDarkMode ? "#fff" : "#667eea",
//                     0.1
                  
//                   )}`,
//                 }}
//                 action={
//                   <Button
//                     startIcon={<FileDownloadIcon />}
//                     sx={{
//                       textTransform: "none",
//                       color: isDarkMode ? "#fff" : "#667eea",
//                       fontWeight: 600,
//                     }}
//                   >
//                     Export to CSV
//                   </Button>
//                 }
//               />
//               <Box sx={{ width: "100%", overflowX: "auto" }}>
//                 <Box sx={{ minWidth: "1200px" }}>
//                   <DataGridMui
//                     height="55vh"
//                     width="100%"
//                     getRowId={(data) => data._id}
//                     columns={columns}
//                     rows={filter}
//                     checkboxSelection={drop !== ""}
//                     onRowSelectionModelChange={(ids) => {
//                       const selectedIDs = new Set(ids);
//                       const selectedRows = filter.filter((row) =>
//                         selectedIDs.has(row._id)
//                       );
//                       setChk(selectedRows);
//                     }}
//                     sx={{
//                       "& .MuiDataGrid-columnHeaders": {
//                         backgroundColor: isDarkMode
//                           ? alpha("#fff", 0.1)
//                           : alpha("#f5f5f5", 0.8),
//                       },
//                       "& .MuiDataGrid-cell": {
//                         borderBottom: `1px solid ${alpha(
//                           isDarkMode ? "#fff" : "#000",
//                           0.1
//                         )}`,
//                       },
//                       "& .MuiDataGrid-row:hover": {
//                         backgroundColor: isDarkMode
//                           ? alpha("#667eea", 0.1)
//                           : alpha("#667eea", 0.05),
//                       },
//                     }}
//                   />
//                 </Box>
//               </Box>
//             </Card>
//           )}
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default withRouter(ManageUser);



import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../utils/loader";
import {
  getAllUsers2,
  searchUser,
  planFilter,
} from "../services/adminServices";
import { withRouter } from "react-router-dom";
import team from "../static/noteams.png";
import DataGridMui from "./ReusableComponents/DataGridMui";

// MUI Imports
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Card,
  Typography,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Chip,
  IconButton,
  Stack,
  useTheme,
  alpha,
  CardHeader,
  Avatar,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import SettingsIcon from "@mui/icons-material/Settings";
import DescriptionIcon from "@mui/icons-material/Description";
import PeopleIcon from "@mui/icons-material/People";
import PaidIcon from "@mui/icons-material/Paid";

const ManageUser = ({ history }) => {
  let [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersBackup, setusersBackup] = useState([]);
  let [chk, setChk] = useState([]);
  const [drop, setDrop] = useState("");
  const [value, setvalue] = useState("");
  const [filter, setfilter] = useState([]);
  const [planFilterDropDown, setPlanFilterDropDown] = useState("all");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const getAllUsers = async () => {
    setLoading(true);
    try {
      const res = await getAllUsers2();
      console.log("getAllUsers", res);
      if (res.status === 200) {
        setUsers(res.data);
        setusersBackup(res.data);
        setfilter(res.data);
        setLoading(false);
      } else {
        setLoading(false);
        console.log("Oops something went wrong");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching users:", error);
      toast.error("Failed to load users");
    }
  };

  const handleCheck = (getObj) => {
    if (!drop) return;
    if (chk.some((obj) => obj._id === getObj._id)) {
      chk = chk.filter((obj) => obj._id !== getObj._id);
    } else {
      chk.push(getObj);
    }
    setChk([...chk]);
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const handleSubmit = () => {
    if (chk.length < 1) {
      if (!drop) {
        toast.error("Please select an action type");
        return;
      }
      toast.error("Please select at least one user");
      return;
    }
    const sendData = chk;
    history.push({
      pathname: `/Newsletter`,
      state: { sendData, type: drop },
    });
  };

  const goToSetting = (obj) => {
    history.push({
      pathname: `/accountsettings`,
      state: { userData: obj },
    });
  };

  const goToDocument = (obj) => {
    history.push({
      pathname: `/mydocuments`,
      state: { userData: obj },
    });
  };

  const filterOnChange = async (e) => {
    const searchValue = e.target.value;
    setvalue(searchValue);

    if (searchValue === "") {
      setfilter(usersBackup);
    } else {
      const timer = setTimeout(async () => {
        try {
          let result = await searchUser(searchValue);
          setfilter(result);
        } catch (error) {
          console.error("Search error:", error);
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  };

  const searchUsername = async () => {
    if (!value.trim()) {
      setfilter(usersBackup);
      return;
    }
    try {
      let result = await searchUser(value);
      setfilter(result);
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Failed to search users");
    }
  };

  const setDropDowm = (selection) => {
    setDrop(selection);
    if (selection === "newsletter") {
      let filterData = usersBackup.filter((obj) => obj.subscription === true);
      setfilter(filterData);
    } else {
      setfilter(usersBackup);
    }
  };

  const FilterPlan = async (value) => {
    setLoading(true);
    setPlanFilterDropDown(value);
    try {
      if (value === "all") {
        setfilter(usersBackup);
      } else {
        let data = await planFilter(value);
        setfilter(data.data);
      }
    } catch (error) {
      console.error("Filter error:", error);
      toast.error("Failed to filter users");
    }
    setLoading(false);
  };

  // Calculate stats
  const totalUsers = users.length;
  const activePlans = users.filter(
    (u) => u.planName && u.planName.toLowerCase() !== "free"
  ).length;
  const freeUsers = users.filter(
    (u) => !u.planName || u.planName.toLowerCase() === "free"
  ).length;
  const newsletterSubscribed = users.filter(
    (u) => u.subscription === true
  ).length;

  // Enhanced columns with proper flex values for full width
  const columns = [
    {
      field: "username",
      headerName: "User Name",
      flex: 0.8,
      minWidth: 180,
      editable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar sx={{ width: 32, height: 32, bgcolor: "#667eea" }}>
            {params.value ? params.value.charAt(0).toUpperCase() : "U"}
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value || "N/A"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "email",
      headerName: "Email Address",
      type: "text",
      flex: 1.2,
      minWidth: 220,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ color: isDarkMode ? "#e0e0e0" : "#555" }}
        >
          {params.value || "N/A"}
        </Typography>
      ),
    },
    {
      field: "country",
      headerName: "Country",
      flex: 0.6,
      minWidth: 120,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.value || "Not Specified"}
        </Typography>
      ),
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 0.7,
      minWidth: 140,
      renderCell: (params) => (
        <Typography variant="body2">{params.value || "N/A"}</Typography>
      ),
    },
    {
      field: "Role",
      headerName: "User Role",
      flex: 0.5,
      minWidth: 100,
      renderCell: (params) => (
        <Chip
          label={params.value || "User"}
          size="small"
          color={params.value === "Admin" ? "primary" : "default"}
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
      ),
    },
    {
      field: "planName",
      headerName: "Subscription Plan",
      flex: 0.7,
      minWidth: 150,
      renderCell: (params) => {
        const plan = params.value || "Free";
        let color = "default";
        if (plan.toLowerCase() === "premium") color = "success";
        if (plan.toLowerCase() === "basic") color = "primary";
        if (plan.toLowerCase() === "pro") color = "warning";

        return (
          <Chip
            label={plan}
            size="small"
            color={color}
            variant="filled"
            sx={{
              fontWeight: 600,
              minWidth: 80,
              color:
                color === "default" ? (isDarkMode ? "#fff" : "#000") : "#fff",
            }}
          />
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.6,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => (
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="Account Settings">
            <IconButton
              size="small"
              onClick={() => goToSetting(params.row)}
              sx={{
                color: isDarkMode ? "#90caf9" : "#1976d2",
                "&:hover": { bgcolor: alpha("#1976d2", 0.1) },
              }}
            >
              <SettingsIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View Documents">
            <IconButton
              size="small"
              onClick={() => goToDocument(params.row)}
              sx={{
                color: isDarkMode ? "#a5d6a7" : "#388e3c",
                "&:hover": { bgcolor: alpha("#388e3c", 0.1) },
              }}
            >
              <DescriptionIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 64px)", // Full height minus header
        width: "100%",
        background: isDarkMode
          ? "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)"
          : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        py: 3,
        px: { xs: 2, md: 4 },
      }}
    >
      <Loader loading={loading} />

      <Grid container spacing={3} sx={{ width: "100%", height: "100%" }}>
        {/* Filters Section */}
        <Grid xs={12}>
          <Card
            sx={{
              background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
              backdropFilter: "blur(10px)",
              border: `1px solid ${
                isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
              }`,
              borderRadius: 3,
              p: 3,
              width: "100%",
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid xs={12} md={4}>
                <TextField
                  fullWidth
                  placeholder="Search by name, email, or phone..."
                  value={value}
                  onChange={filterOnChange}
                  onKeyPress={(e) => e.key === "Enter" && searchUsername()}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          sx={{
                            color: isDarkMode
                              ? alpha("#fff", 0.5)
                              : alpha("#000", 0.5),
                          }}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: value && (
                      <InputAdornment position="end">
                        <Button
                          size="small"
                          onClick={() => {
                            setvalue("");
                            setfilter(usersBackup);
                          }}
                          sx={{ minWidth: "auto" }}
                        >
                          Clear
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: isDarkMode
                        ? alpha("#fff", 0.05)
                        : alpha("#667eea", 0.05),
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: isDarkMode
                          ? alpha("#fff", 0.1)
                          : alpha("#667eea", 0.2),
                      },
                      "&:hover fieldset": {
                        borderColor: "#667eea",
                      },
                      "& input": {
                        color: isDarkMode ? "#fff" : "#2c3e50",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel
                    sx={{
                      color: isDarkMode
                        ? alpha("#fff", 0.7)
                        : alpha("#2c3e50", 0.7),
                    }}
                  >
                    Plan Type
                  </InputLabel>
                  <Select
                    value={planFilterDropDown}
                    label="Plan Type"
                    onChange={(e) => FilterPlan(e.target.value)}
                    sx={{
                      backgroundColor: isDarkMode
                        ? alpha("#fff", 0.05)
                        : alpha("#667eea", 0.05),
                      borderRadius: 2,
                      color: isDarkMode ? "#fff" : "#2c3e50",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: isDarkMode
                          ? alpha("#fff", 0.1)
                          : alpha("#667eea", 0.2),
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#667eea",
                      },
                    }}
                  >
                    <MenuItem value="all">All Plan Types</MenuItem>
                    <MenuItem value="free">Free Plan</MenuItem>
                    <MenuItem value="basic">Basic Plan</MenuItem>
                    <MenuItem value="premium">Premium Plan</MenuItem>
                    <MenuItem value="pro">Pro Plan</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel
                    sx={{
                      color: isDarkMode
                        ? alpha("#fff", 0.7)
                        : alpha("#2c3e50", 0.7),
                    }}
                  >
                    Bulk Actions
                  </InputLabel>
                  <Select
                    value={drop}
                    label="Bulk Actions"
                    onChange={(e) => setDropDowm(e.target.value)}
                    sx={{
                      backgroundColor: isDarkMode
                        ? alpha("#fff", 0.05)
                        : alpha("#667eea", 0.05),
                      borderRadius: 2,
                      color: isDarkMode ? "#fff" : "#2c3e50",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: isDarkMode
                          ? alpha("#fff", 0.1)
                          : alpha("#667eea", 0.2),
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#667eea",
                      },
                    }}
                  >
                    <MenuItem value="">Select Action</MenuItem>
                    <MenuItem value="newsletter">Send Newsletter</MenuItem>
                    <MenuItem value="email">Send Email</MenuItem>
                    <MenuItem value="notification">Send Notification</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid xs={12} md={2}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={!drop || chk.length === 0}
                  startIcon={<EmailIcon />}
                  sx={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "#fff",
                    borderRadius: 2,
                    py: 1.5,
                    textTransform: "none",
                    fontWeight: 600,
                    "&:disabled": {
                      opacity: 0.5,
                    },
                    "&:hover:not(:disabled)": {
                      background:
                        "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px ${alpha("#667eea", 0.4)}`,
                    },
                  }}
                >
                  {drop ? `Send ${drop}` : "Select Action"}
                </Button>
              </Grid>
            </Grid>

            {chk.length > 0 && (
              <Box
                sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}
              >
                <Chip
                  label={`${chk.length} user(s) selected`}
                  color="primary"
                  onDelete={() => setChk([])}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: isDarkMode ? alpha("#fff", 0.7) : "#64748b",
                    ml: 1,
                  }}
                >
                  Click "Send {drop}" to proceed
                </Typography>
              </Box>
            )}
          </Card>
        </Grid>

        {/* Data Grid Section */}
        <Grid xs={12} sx={{ height: "calc(100vh - 280px)", minHeight: "400px" }}>
          {filter.length === 0 ? (
            <Card
              sx={{
                background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
                backdropFilter: "blur(10px)",
                border: `1px solid ${
                  isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
                }`,
                borderRadius: 3,
                p: 6,
                textAlign: "center",
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={team}
                alt="No Teams"
                style={{ maxWidth: "300px", opacity: 0.6 }}
              />
              <Typography
                variant="h5"
                sx={{
                  mt: 3,
                  color: isDarkMode ? "#fff" : "#2c3e50",
                  fontWeight: 600,
                }}
              >
                No users found!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  color: isDarkMode ? alpha("#fff", 0.7) : "#64748b",
                }}
              >
                Try adjusting your search or filter criteria
              </Typography>
            </Card>
          ) : (
            <Card
              sx={{
                background: isDarkMode ? alpha("#fff", 0.05) : "#fff",
                backdropFilter: "blur(10px)",
                border: `1px solid ${
                  isDarkMode ? alpha("#fff", 0.1) : alpha("#000", 0.05)
                }`,
                borderRadius: 3,
                overflow: "hidden",
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardHeader
                title="User Management Dashboard"
                sx={{
                  background: isDarkMode
                    ? alpha("#fff", 0.05)
                    : alpha("#667eea", 0.05),
                  borderBottom: `1px solid ${alpha(
                    isDarkMode ? "#fff" : "#667eea",
                    0.1
                  )}`,
                  py: 2,
                }}
                action={
                  <Button
                    startIcon={<FileDownloadIcon />}
                    sx={{
                      textTransform: "none",
                      color: isDarkMode ? "#fff" : "#667eea",
                      fontWeight: 600,
                    }}
                  >
                    Export to CSV
                  </Button>
                }
              />
              <Box sx={{ 
                width: "100%", 
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
              }}>
                <Box sx={{ 
                  width: "100%",
                  height: "100%",
                  minWidth: "1200px",
                }}>
                  <DataGridMui
                    height="100%"
                    width="100%"
                    getRowId={(data) => data._id}
                    columns={columns}
                    rows={filter}
                    checkboxSelection={drop !== ""}
                    onRowSelectionModelChange={(ids) => {
                      const selectedIDs = new Set(ids);
                      const selectedRows = filter.filter((row) =>
                        selectedIDs.has(row._id)
                      );
                      setChk(selectedRows);
                    }}
                    sx={{
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: isDarkMode
                          ? alpha("#fff", 0.1)
                          : alpha("#f5f5f5", 0.8),
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: `1px solid ${alpha(
                          isDarkMode ? "#fff" : "#000",
                          0.1
                        )}`,
                      },
                      "& .MuiDataGrid-row:hover": {
                        backgroundColor: isDarkMode
                          ? alpha("#667eea", 0.1)
                          : alpha("#667eea", 0.05),
                      },
                    }}
                  />
                </Box>
              </Box>
            </Card>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default withRouter(ManageUser);
